import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useEffect, useState} from "react";
import {Button} from "react-bootstrap";

const TopBarActions = ({actions, filtersRef}) => {
    const activesDefault = {
        delete: false,
        filter: false,
        trash: false,
        markAllAsRead: false,
    };
    const [actives, setActives] = useState(activesDefault);
    const notAction = ["title", "searcher", "counter"];

    if (actions?.title) {
        document.title = actions.title;
    }

    useEffect(() => {
        for (let action in actions) {
            if (notAction.includes(action)) {
                continue;
            }
            setActives((data) => ({...data, [action]: actions[action].active}));
        }
    }, [actions]);

    return (
        <>
            <nav className="navbar navbar-expand actions-control w-100">
                <div className="d-flex m-2 ms-5 w-100">
                    <div className="navbar-brand me-2">{actions.title}</div>
                    <button
                        className="navbar-toggler "
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent "
                        aria-controls="navbarSupportedContent"
                        aria-expanded="false"
                        aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div id="navbarSupportedContent" className="w-100">
                        <ul className="navbar-nav ">
                            {actives.delete ? (
                                <li className="nav-item me-2">
                                    <Button
                                        variant="link"
                                        type="button"
                                        onClick={actions.delete.onClick}
                                        disabled={actions.delete.disabled}>
                                        <FontAwesomeIcon icon="fa-trash" />
                                    </Button>
                                </li>
                            ) : (
                                <> </>
                            )}

                            {actives.trash ? (
                                <li className="nav-item me-2">
                                    <Button
                                        variant="link"
                                        type="button"
                                        onClick={actions.trash.onClick}
                                        disabled={actions.trash.disabled}>
                                        <FontAwesomeIcon icon="fa-solid fa-trash-arrow-up" />
                                    </Button>
                                </li>
                            ) : (
                                <></>
                            )}

                            {actives.filter ? (
                                <li className="nav-item me-2">
                                    <Button
                                        variant="link"
                                        type="button"
                                        onClick={actions.filter.onClick}
                                        aria-controls="filter-collapse"
                                        aria-expanded="false"
                                        style={
                                            actions.filter.applied
                                                ? !actions.filter.click
                                                    ? {color: "orange"}
                                                    : {color: "#03d503"}
                                                : !actions.filter.click
                                                ? {color: ""}
                                                : {color: "#03d503"}
                                        }>
                                        <FontAwesomeIcon icon="fa-solid fa-filter" />
                                    </Button>
                                </li>
                            ) : (
                                <></>
                            )}

                            {actives.topBack ? (
                                <li className="nav-item me-2">
                                    <Button
                                        variant="link"
                                        type="button"
                                        onClick={actions.topBack.onClick}
                                        disabled={actions.topBack.disabled}>
                                        <FontAwesomeIcon icon="fa-solid fa-arrow-turn-up" transform={{rotate: -90}} />
                                    </Button>
                                </li>
                            ) : (
                                <></>
                            )}

                            {actives.markAllAsRead ? (
                                <li className="nav-item me-2">
                                    <Button
                                        variant="link"
                                        type="button"
                                        onClick={actions.markAllAsRead.onClick}
                                        disabled={actions.markAllAsRead.disabled}
                                        title={actions.markAllAsRead.label}>
                                        <FontAwesomeIcon icon="fa-eye" />
                                    </Button>
                                </li>
                            ) : (
                                <></>
                            )}
                        </ul>
                    </div>
                </div>
            </nav>
            <div className="row" style={{height: "55px"}}></div>
        </>
    );
};

export default TopBarActions;
